export const TABLE_HEADER_FONT_SIZE = 13;
export const TABLE_COMPACT_HEADER_HEIGHT = "23px";
export const TABLE_COMPACT_HEADER_PADDING = "16px";
export const TABLE_BODY_ROW_HEIGHT = "55px";
export const BROKERS_IBS_PANEL_HEIGHT = "438px";
export const TABLE_INITIAL_ROWS_PER_PAGE = 10;
export const BROKERS_WALLET_EMAIL_STORAGE_KEY = "brokersibs_wallet_email";
export const BROKERS_IBS_REPORT_SEARCH_ID_STORAGE_KEY =
  "brokersibs_reports_search_id";
export const buildTableRowsPerPageOptions = (options = []) =>
  Array.from(new Set([TABLE_INITIAL_ROWS_PER_PAGE, ...options])).sort(
    (left, right) => left - right
  );
